import { Injectable, inject } from '@angular/core';

import { AuthService } from '../../auth/auth.service';
import { DslRecorderService } from '../dsl-recorder.service';
import { DslRecordable, DslValuesProvider } from '../dsl.models';

@Injectable()
export class AuthenticationDslValuesProvider implements DslValuesProvider {
    private readonly dslRecorderService = inject(DslRecorderService);
    private readonly authService = inject(AuthService);

    getProviders(): { [provider: string]: DslRecordable } {
        return {
            Authentication: this.dslRecorderService.createRecordable('authentication').createAction({
                name: 'Logout',
                fn: () => this.authService.logout({ redirectAfterLogout: false }),
            }),
        };
    }
}
